import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://hlbwsasvgnkatfcppnad.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_LWe9mAvrZtEPUaDwjO3AZQ_Nf2CJND2';

// Initialize Supabase client (using placeholder values if not configured)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
